export function createAgentEventMessage({ source, sessionId, event }) {
  return { source, sessionId, event };
}

export function shouldReplyToSnapshotRequest({ localStreamingSessionId, sessionId }) {
  return localStreamingSessionId != null && String(localStreamingSessionId) === String(sessionId);
}

export function shouldApplyStreamSnapshot({ localStreamingSessionId, sessionId, messages }) {
  return Array.isArray(messages) && String(localStreamingSessionId) !== String(sessionId);
}
